import { CHANNEL } from '../../constants/messageTemplateKeys';

export function resolveTabKey(tabKey) {
  return String(tabKey) === 'text' ? 'text' : CHANNEL.EMAIL;
}
